import { schema_chat_message } from 'adv-lib/src/models/chat/chat-message/chat-message'
import { schema_user_pick_s_member } from 'adv-lib/src/models/pick/user-pick/user-pick-s-member'
import { BET_HIT_STATE, MATCH_STATUS } from 'adv-protocol/src/GameCommon'
import { Schema$CheerForTeamData } from 'adv-lib/src/v2/protocol/chat'
import { CHEER_FOR_TEAM_CONTENTS_TYPE } from 'adv-lib/src/v2/constants/cheer'
import { UserActivityInfo } from 'adv-lib/src/v2/interface/user-activity'
import { CHAT_CONTENT_BUTTON_TYPE } from 'adv-lib/src/v2/constants/common'

export enum ChatMessageType {
  TEXT_ONLY, EMOTICON, IMAGE, BET_HISTORY, USER_PICK, CHEER_FOR_TEAM,
}

export const ChatMessageTypeStr = {
  [ChatMessageType.TEXT_ONLY]: '텍스트',
  [ChatMessageType.EMOTICON]: '이모티콘',
  [ChatMessageType.IMAGE]: '이미지',
  [ChatMessageType.BET_HISTORY]: '배팅내역',
  [ChatMessageType.USER_PICK]: '나도 승부사',
  [ChatMessageType.CHEER_FOR_TEAM]: '응원글',
}

export enum ChatMessageState {
  DISABLE, ENABLE,
}

export enum ChatFontSize {
  SMALL, LARGE,
}

export enum SendMessageToEnterType {
  M_OFF_PC_ON, // default
  M_ON_PC_ON,
  M_ON_PC_OFF,
  M_OFF_PC_OFF,
}

export enum ChatMessageSearchType {
  FROM_USER_NICK,
  TO_USER_NICK,
  CONTENTS,
  NO_CHAT_USER,
  HIDDEN_CHAT,
  HIDDEN_CONTENTS,
  HIDDEN_ATTACHMENT,
  CHAT_ID,
}

export const ChatMessageSearchTypeStr = {
  [ChatMessageSearchType.FROM_USER_NICK]: '닉네임',
  [ChatMessageSearchType.TO_USER_NICK]: '대상닉네임',
  [ChatMessageSearchType.CONTENTS]: '내용',
  [ChatMessageSearchType.NO_CHAT_USER]: '채금유저',
  [ChatMessageSearchType.HIDDEN_CHAT]: '채팅가림',
  [ChatMessageSearchType.HIDDEN_CONTENTS]: '내용가림',
  [ChatMessageSearchType.HIDDEN_ATTACHMENT]: '첨부가림',
  [ChatMessageSearchType.CHAT_ID]: '채팅아이디',
}

export enum NotChatTime { // 현재 사용안함. 그냥 참고용. 설정은 어드민 글로벌에 있다.
  NC_1_M = 'NC_1_M', NC_5_M = 'NC_5_M', NC_10_M = 'NC_10_M', NC_30_M = 'NC_30_M',
  NC_1_H = 'NC_1_H', NC_2_H = 'NC_2_H', NC_24_H = 'NC_24_H',
  NC_1_W = 'NC_1_W', NC_2_W = 'NC_2_W',
  NC_1_MO = 'NC_1_MO', NC_2_MO = 'NC_2_MO',
  NC_UNLIMITED = 'NC_UNLIMITED',
}

export enum UserPenaltyTime { // 그냥 참고용. 설정은 어드민 글로벌에 있다.
  UPT_1_M = 'UPT_1_M', UPT_5_M = 'UPT_5_M', UPT_10_M = 'UPT_10_M', UPT_30_M = 'UPT_30_M',
  UPT_1_H = 'UPT_1_H', UPT_2_H = 'UPT_2_H', UPT_3_H = 'UPT_3_H', UPT_6_H = 'UPT_6_H', UPT_24_H = 'UPT_24_H',
  UPT_1_W = 'UPT_1_W', UPT_2_W = 'UPT_2_W',
  UPT_1_MO = 'UPT_1_MO', UPT_2_MO = 'UPT_2_MO',
  UPT_UNLIMITED = 'UPT_UNLIMITED',
}

export enum ExtensionType {
  JPEG, PNG, GIF, ETC,
}

export interface TinySimpleBetHistory {
  foldCount: number
  lastRate: string
}

export interface ChattingOptions { // 어드민 글로벌에서 관리
  totalLimit: number // 채팅이 유지될 총 갯수
  lazyLoadLimit: number // 스크롤 상단 이동시 로드할 채팅 갯수
  active: boolean // 채팅 활성화 여부
  activeLiveScore: boolean // 채팅 상단 라이브 스코어 활성화 여부
  activeImageAttach: boolean // 이미지 첨부 가능 여부
  activeEmoticonAttach: boolean // 이모티콘 첨부 가능 여부
  activeBetHistoryAttach: boolean // 배팅 내역 첨부 가능 여부
  myReplyMessageFetchLimitTime: number // 내 지정 채팅 가지고올 최대 시간 단위(시간) (24: 24시간전 부터 현재까지)
  sharedBetHistoryFetchLimitTime: number // 배팅 내역 공유 메시지 가지고 올 최대 시간 단위(시간) (8: 8시간전 부터 현재까지)
  invisibleContentsMessage: string // 채팅 메시지 차단시 보여줄 대체 메시지.
  emoticonVersion: number // 이모티콘 버전
  activeCheerForTeam: boolean // 채팅 응원글 활성화 여부
  gifRepeat: number
  maxWidth: number
  maxSmallWidth: number
}

export interface ChattingUserOptions { // 유저별 설정
  noChattingTime: number // 채금 시간 단위(분) (어드민설정)
  activeChat: boolean // 채팅 활성화 여부 (어드민설정)
  activeImageAttach: boolean // 이미지 첨부 가능 여부 (어드민설정)
  activeEmoticonAttach: boolean // 이모티콘 첨부 가능 여부 (어드민설정)
  activeBetHistoryAttach: boolean // 배팅 내역 첨부 가능 여부 (어드민설정)
  showChattingPreviewMainMessage: boolean // 채팅 창 닫았을때 나오는 상단 토스트 메시지 출력 여부(유저 설정)
}

export interface SelectComponentOption {
  id: string
  value: string
}

export interface ChatAvailableUserInfo {
  id: string
  nick: string
  avatar: string // image full s3 url
}

export enum CHAT_SOCKET_EVENT {
  ON_CHAT_MESSAGE = '/topic/chat/chatMessage',
  ON_UPDATE_CHAT_MESSAGE = '/topic/chat/updateChatMessage',
  ON_VISIBLE_CHAT_COUNT_INFO = '/topic/chat/visibleChatCountInfo',

  ON_ALL_CHAT_MESSAGE = '/user/topic/chat/allChatMessage',
  ON_ALL_SHARED_BET_HISTORY_MESSAGE = '/user/topic/chat/allSharedBetHistoryMessage',
  ON_ALL_MY_REPLY_MESSAGE = '/user/topic/chat/allMyReplyMessage',
  ON_CHAT_ERROR_MESSAGE = '/user/topic/chat/chatErrorMessage',
  ON_VISIBLE_CHAT_MEMBER_COUNT = '/user/topic/chat/visibleChatMemberCount',
  ON_PRE_DISCONNECT = '/user/topic/chat/preDisconnect',

  SEND_CHAT_MESSAGE = '/chat/chatMessage',
  GET_ALL_CHAT_MESSAGE = '/chat/allChatMessage',
  GET_ALL_SHARED_BET_HISTORY_MESSAGE = '/chat/allSharedBetHistoryMessage',
  GET_ALL_MY_REPLY_MESSAGE = '/chat/allMyReplyMessage',
  VISIBLE_CHAT = '/chat/visibleChatMessage',
  INVISIBLE_CHAT = '/chat/invisibleChatMessage',
  GET_VISIBLE_CHAT_MEMBER_COUNT = '/chat/visibleChatMemberCount',
  PRE_DISCONNECT = '/chat/preDisconnect',

  ON_CONNECTED = 'onConnected',
  ON_DISCONNECTED = 'onDisconnected',

  RECONNECT = 'reconnect',
  RECONNECTION_ATTEMPT = 'reconnection_attempt',
  ON_RECONNECT = '/topic/chat/reconnect',
  ON_RECONNECTION_ATTEMPT = '/topic/chat/reconnection_attempt',
  ON_EXCEPTION = 'exception',

  ON_CONNECT_ERROR = 'connect_error',

  GET_ENDED_SIMPLE_MATCH_GROUP_LIST = '/chat/endedSimpleMatchTimelineGroupList',
  ON_ENDED_SIMPLE_MATCH_LIST = '/user/topic/chat/endedSimpleMatchTimelineGroupList',
}

export interface ChatSettingLog {
  chatId?: string
  userId?: string
  nick?: string
  type?: string
  typeId?: number
  selectId: string
  desc: string
  reason?: string
  adminId: string
  adminName: string
  createdAt: Date
  logType: number
}

export interface NoChatUserListInfo {
  id: string // user promise id
  nick: string
  noChattingTime: Date
  noChattingTimeType: string
  noChattingReason: string
  remainingTimeText?: string
}

export const ChatSettingLogType = {
  NO_CHAT: 'NO_CHAT',
  IMAGE_ATTACH: 'IMAGE_ATTACH',
  BET_HISTORY_ATTACH: 'BET_HISTORY_ATTACH',
  CHAT_CONTENTS: 'CHAT_CONTENTS',
  CHAT_MESSAGE: 'CHAT_MESSAGE',
  CHAT_OPTIONS: 'CHAT_OPTIONS',
  USER_PROFILE_IMG: 'USER_PROFILE_IMG',
}

export const ChatSettingLogTypeText = {
  NO_CHAT: '채팅제한',
  IMAGE_ATTACH: '이미지 첨부',
  BET_HISTORY_ATTACH: '배팅내역 첨부',
  CHAT_CONTENTS: '채팅내용',
  CHAT_MESSAGE: '채팅',
  CHAT_OPTIONS: '채팅설정',
  USER_PROFILE_IMG: '유저 프로필',
}

export interface SimpleChatUserInfo {
  id: string // user promise id
  nick: string
  fromUserId?: string
  fromUserNick?: string
}

export interface SimpleEmoticonInfo {
  img: string // adv_v2/emoji.gif
  pvImg: string // preview image
}

export interface VisibleUserInfo { // socket 유저 접속 정보를 확인하기 위한 데이터.
  userId: string
  userNick: string
  mobile: boolean // boolean value
  sessionId?: string // socket.io client id
}

export interface VisibleChatMemberCount {
  total: number
  session: number // session 카운트
  mobile: number // 모바일 카운트
  pc: number // PC 카운트
}

export interface SportEvent {

}

export interface SportEventStatus {

}

export const TimelineEventType = {
  MATCH_STARTED: 'match_started',
  PERIOD_START: 'period_start',
  PERIOD_SCORE: 'period_score',
  BREAK_START: 'break_start',
  SCORE_CHANGE: 'score_change',
  MATCH_ENDED: 'match_ended',
  CORNER_KICK: 'corner_kick',
  YELLOW_CARD: 'yellow_card',
  RED_CARD: 'red_card',
  YELLOW_RED_CARD: 'yellow_red_card',
}

export enum TimelineEventAssistType {
  PRIMARY, SECONDARY,
}

export interface UrnId {
  prefix: string
  type: string
  id: number
}

export interface Player {
  id: UrnId
  name: string // 선수 이름
}

export interface GoalScorer {
  id: UrnId
  name: string // 선수 이름
  method?: string // 축구 패널티킥 득점. penalty or own goal(이건 어디쓰는지 모름)
}

export interface Assist {
  id: UrnId
  type: TimelineEventAssistType
  name: string // 선수 이름
}

export interface TimelineEvent {
  id: number
  type: string
  time: number
  period: number
  periodName: string
  matchStatusCode: number
  matchStatusName: string
  matchTime: number
  matchClock: string // 경기가 시작된 후 경과 시간
  homeScore: number
  awayScore: number
  addScore: number
  team: string // 'home' or 'away'
  player: Player // 옐로카드나 코너킥등
  goalScorer: GoalScorer
  assistList: Assist[]
}

export type ScoreType = 'regular_period' | 'overtime' | 'penalties'

export interface PeriodScore {
  homeScore: number
  awayScore: number
  type: ScoreType
  number: number // period number
  matchStatusCode: MATCH_STATUS
  matchStatusName: string
}

export interface PeriodInfo {
  homeScore: number
  awayScore: number
  number: number // period number
  matchStatusCode: number
  matchStatusName: string
  timelineEventList: TimelineEvent[]
}

export interface Statistics {
  teamId: number
  cards: number
  cornerKicks: number
  yellowCards: number
  redCards: number
}

export interface SimpleMatchTimeline {
  matchId: number
  sportId: number
  sportName: string
  dateOfMatch: number
  homeId: number
  awayId: number
  homeName: string
  awayName: string
  homeScore: number
  awayScore: number
  homeTeamEmblem: string
  awayTeamEmblem: string
  matchStatusCode: number
  matchStatusName: string
  statusCode: number
  statusName: string
  emblemSport: string
  tournamentId: number
  tournamentName: string
  emblemTournament: string
  categoryId: number
  categoryName: string
  emblemCategory: string
  homeStatistics: Statistics
  awayStatistics: Statistics
  periodScoreList: PeriodScore[]
  periodInfoList: PeriodInfo[]
  matchStartedAt: Date
  matchEndedAt: Date
}

export interface SimpleMatchTimelineGroup {
  sportId: number
  sportName: string
  categoryId: number
  categoryName: string
  tournamentId: number
  tournamentName: string
  emblemSport: string
  emblemCategory: string
  emblemTournament: string
  simpleMatchTimelineList: SimpleMatchTimeline[]
}

export interface Schema$ChatMessage extends Partial<schema_chat_message> {
  sMember: schema_user_pick_s_member
  sMemberMark: boolean
  userTitleId: number
  userTitleEnabled: boolean
  cheerForTeamId: number
  cheerForTeamData: Schema$CheerForTeamData
  cheerForTeamContentsType: CHEER_FOR_TEAM_CONTENTS_TYPE
  activityInfoList?: UserActivityInfo[]
}

export type ChatBetHistoryType = {
  bettorBetId: string // bettor_bet id
  betId: string // bettor_bet betId (클럽벳 조회용 - 어드민에서사용)
  foldCount: number
  dividendRate: string
  hitState: BET_HIT_STATE
  sportIds: number[] // 베팅 폴드별 스포츠아이디. 중복제거된 sportId로 5자리수 sportId 기준 60자 이하 사용
}

export type ChatCheerForTeamDetailType = {
  cheerForTeamItem: Schema$CheerForTeamData,
  uploadedImageSrc?: string,
  emoticonUrl?: string,
  betHistory?: ChatBetHistoryType,
}

export type ChatContentButtonOption = {
  buttonType: CHAT_CONTENT_BUTTON_TYPE
  order: number
  orderFixed: boolean
  desc: string
  enabled: boolean
}


